import { render, staticRenderFns } from "./SearchTokenPayoutHeader.vue?vue&type=template&id=9985dc68&"
import script from "./SearchTokenPayoutHeader.vue?vue&type=script&lang=js&"
export * from "./SearchTokenPayoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchTokenPayoutHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports